import React from "react";
import { Page } from "../models/story";
import "./MinimizedPage.css";

type Props = {
  page: Page | undefined;
};

const MinimizedPage = (props: Props) => {
  const { page } = props;

  return (
    <div className="minimized-page">
      <div
        className={
          "minimized-page__image-wrap" +
          (page?.aspectRatio ? " minimized-page__image-wrap--fixed" : "")
        }
        style={
          page?.aspectRatio ? { aspectRatio: page.aspectRatio } : undefined
        }
      >
        <img src={page?.image} alt="" className="minimized-page__image" />
      </div>
      {page?.showPageNumber ? (
        <p className="minimized-page__text">{page.text}</p>
      ) : null}
    </div>
  );
};

export default MinimizedPage;
